export const getRiojaData = () => ({
  name: "Rioja",
  country: "Espagne",
  description: "Rioja est la région viticole la plus prestigieuse d'Espagne, reconnue mondialement pour ses vins rouges élégants et complexes, principalement à base de Tempranillo.",
  type: "region",
  subregions: [
    { name: "Rioja Alta", area: "25,000 ha", percentage: "38%", description: "Vins élégants et équilibrés" },
    { name: "Rioja Alavesa", area: "12,000 ha", percentage: "18%", description: "Vins fins et aromatiques" },
    { name: "Rioja Baja", area: "28,000 ha", percentage: "44%", description: "Vins puissants et fruités" }
  ],
  mapAreas: [
    { region: "Rioja Alta", x: 42, y: 32, color: "#4B164C", size: 6 },
    { region: "Rioja Alavesa", x: 45, y: 35, color: "#6d2c7a", size: 5 },
    { region: "Rioja Baja", x: 48, y: 38, color: "#8a4a8a", size: 7 }
  ],
  statistics: {
    totalArea: "65,000 ha",
    production: "280 million litres",
    wineries: "600+ bodegas",
    appellations: "3 sous-régions",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat continental tempéré avec influences atlantiques",
    soil: "Sols calcaires et argilo-calcaires, galets roulés",
    viticulture: "Rendements limités, vendanges manuelles, élevage en barriques"
  },
  wineStyles: {
    red: "Vins rouges structurés et élégants, avec des notes de vanille et de fruits rouges",
    white: "Vins blancs secs et aromatiques, principalement de Viura",
    rosé: "Rosés fruités et équilibrés, parfaits pour l'apéritif"
  },
  history: "La viticulture à Rioja remonte aux Romains. Au XIXe siècle, les vignerons bordelais ont introduit les techniques d'élevage en barriques. En 1925, Rioja obtient la première appellation d'origine d'Espagne. Aujourd'hui, c'est la référence mondiale des vins espagnols.",
  foodPairing: "Viandes rouges, agneau, fromages affinés, tapas traditionnelles"
}); 